module.exports = {
    "development": {
        "localhost:8080": {
			url: "http://localhost:7000"
		}
    },
    "production": {
        "kiosk.mediport.dev.qarts.eu": {
            url: "https://api.mediport.dev.qarts.eu"
        },
        "kiosk.mediris.dev.qarts.eu": {
            url: "https://api.mediris.dev.qarts.eu"
        },
        "kiosk.ubecare.dev.qarts.eu": {
            url: "https://api.ubecare.dev.qarts.eu"
        },
        "kiosk.partheas.dev.qarts.eu": {
            url: "https://api.partheas.dev.qarts.eu"
        },
        "kiosk.cdg.dev.qarts.eu": {
            url: "https://api.cdg.dev.qarts.eu"
        },
        "kiosk.ocs.dev.qarts.eu": {
            url: "https://api.ocs.dev.qarts.eu"
        },
        "kiosk.medicis.dev.qarts.eu": {
            url: "https://api.medicis.dev.qarts.eu"
        },
        "kiosk.beukenlaan.dev.qarts.eu": {
            url: "https://api.beukenlaan.dev.qarts.eu"
        },
        "kiosk.healthhub.dev.qarts.eu": {
            url: "https://api.healthhub.dev.qarts.eu"
        },
        "kiosk.doclr.dev.qarts.eu": {
            url: "https://api.doclr.dev.qarts.eu"
        },
        "kiosk.devaart.dev.qarts.eu": {
            url: "https://api.devaart.dev.qarts.eu"
        },
        "kiosk.dkl.dev.qarts.eu": {
            url: "https://api.dkl.dev.qarts.eu"
        },
        "kiosk.cdiest.dev.qarts.eu": {
            url: "https://api.cdiest.dev.qarts.eu"
        },
        "kiosk.torhout.dev.docleas.eu": {
            url: "https://api.torhout.dev.docleas.eu"
        },
        "kiosk.grimbergen.dev.docleas.eu": {
            url: "https://api.grimbergen.dev.docleas.eu"
        },
        "PRODUCTION.TENANT_P": {
            url: "PRODUCTION.TENANT_P_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_Q": {
            url: "PRODUCTION.TENANT_Q_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_R": {
            url: "PRODUCTION.TENANT_R_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_S": {
            url: "PRODUCTION.TENANT_S_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_T": {
            url: "PRODUCTION.TENANT_T_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_U": {
            url: "PRODUCTION.TENANT_U_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_V": {
            url: "PRODUCTION.TENANT_V_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_W": {
            url: "PRODUCTION.TENANT_W_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_X": {
            url: "PRODUCTION.TENANT_X_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_Y": {
            url: "PRODUCTION.TENANT_Y_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_Z": {
            url: "PRODUCTION.TENANT_Z_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_1": {
            url: "PRODUCTION.TENANT_1_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_2": {
            url: "PRODUCTION.TENANT_2_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_3": {
            url: "PRODUCTION.TENANT_3_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_4": {
            url: "PRODUCTION.TENANT_4_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_5": {
            url: "PRODUCTION.TENANT_5_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_6": {
            url: "PRODUCTION.TENANT_6_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_7": {
            url: "PRODUCTION.TENANT_7_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_8": {
            url: "PRODUCTION.TENANT_8_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_9": {
            url: "PRODUCTION.TENANT_9_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_10": {
            url: "PRODUCTION.TENANT_10_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_11": {
            url: "PRODUCTION.TENANT_11_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_12": {
            url: "PRODUCTION.TENANT_12_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_13": {
            url: "PRODUCTION.TENANT_13_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_14": {
            url: "PRODUCTION.TENANT_14_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_15": {
            url: "PRODUCTION.TENANT_15_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_16": {
            url: "PRODUCTION.TENANT_16_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_17": {
            url: "PRODUCTION.TENANT_17_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_18": {
            url: "PRODUCTION.TENANT_18_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_19": {
            url: "PRODUCTION.TENANT_19_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_20": {
            url: "PRODUCTION.TENANT_20_API_REDIRECT_URL"
        }
    }
}